import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LanguageService } from '../../services';
import { addEvent, removeEvent } from '../../helpers';
import getFlagIconClassname from '../../helpers/getFlagIconClassname';
import LanguageSlice from '../../common/slices/LanguageSlice';
import { AppDispatch } from '../../reducers/store';
import useLanguages from '../../hooks/useLanguages';
import styles from './NavLanguage.module.scss';

export function NavLanguage() {
    const currentLocale = useSelector(LanguageSlice.state.getLocale);
    const allowedLanguages = useLanguages();
    const disabled = useSelector(LanguageSlice.state.getNavDisabled);

    const dispatch = useDispatch<AppDispatch>();
    const [isOpen, setIsOpen] = useState(false);
    const locales = LanguageService.getLocales();
    let nav: HTMLDivElement | null = null;

    useEffect(() => {
        const eventName = 'click';
        if (isOpen) {
            addEvent(window, eventName, hideMenu);
        } else {
            removeEvent(window, eventName, hideMenu);
        }

        return () => removeEvent(window, eventName, hideMenu);

        function hideMenu(event: any) {
            if (!isOpen) {
                return;
            }

            if (!nav) {
                return;
            }

            if (event.target !== nav && !nav.contains(event.target)) {
                setIsOpen(false);
            }
        }
    }, [isOpen, nav]);

    useEffect(() => {
        if (disabled) {
            setIsOpen(false);
        }
    }, [disabled]);

    return (
        <div
            className={styles.language}
            onClick={toggleList}
            ref={(node) => (nav = node)}
        >
            <div
                id="nav-language-current"
                className={getFlagIconClassname(currentLocale)}
            />
            {renderList()}
        </div>
    );

    function renderList() {
        if (!isOpen) {
            return null;
        }

        return <ul>{locales.map(renderItem)}</ul>;
    }

    function renderItem(locale: string, index: number) {
        if (
            currentLocale === locale ||
            !allowedLanguages.includes(locale.toLowerCase())
        ) {
            return null;
        }

        const language = LanguageService.getLanguageNativeName(locale);

        return (
            <li key={index} onClick={changeLocale(locale)}>
                {language}
            </li>
        );
    }

    function changeLocale(locale) {
        return async () => {
            dispatch(LanguageSlice.actions.setLoading(true));
            await dispatch(LanguageSlice.actions.changeLocale(locale));
        };
    }

    function toggleList() {
        if (disabled) {
            setIsOpen(false);
            return;
        }

        setIsOpen(!isOpen);
    }
}
